// extracted by mini-css-extract-plugin
export default {"container":"Transition__container___DiuG8"};